<template lang="pug">
nav(
    v-if="navbarData"
    class="relative"
    :class="mainCss"
)

    div(class="flex justify-between h-[52px] overflow-hidden lg:container")
        div(
            v-if="!$device.isSmall"
            data-testid="navigationBar"
            class="flex flex-1 flex-wrap gap-x-4"
        )
            //- Loop over Data
            template(v-for="item in navbarData.items")
                template(v-if="$storyblok.isVisible(item)")
                    AbTestWidget(v-if="item.component === 'ab-test-widget'" :data="item")
                    NavItem(v-else :data="item")
                        template(#default="{ isMenuOpen }")
                            UniversalLink(
                                data-testid="navigationBarLink-text-menu-item"
                                v-if="item.component === 'text-menu-item'"
                                :link="item.link.url"
                                :hasColorOverride="true"
                                class="px-3 h-[52px] font-bold flex items-center cursor-pointer whitespace-nowrap hover:no-underline text-sm"
                                :class="[linkClasses.hover, isMenuOpen ? linkClasses.open : linkClasses.closed]"
                            ) {{item.text}}
                            div(v-else
                                :data-testid="`navigationBarLink-${item.component}`"
                                class="px-3 h-[52px] font-bold flex items-center cursor-default whitespace-nowrap hover:no-underline text-sm"
                                :class="[linkClasses.hover, isMenuOpen ? linkClasses.open : linkClasses.closed]"
                            ) {{item.text}}

        FitmentButton(
            :icon="navbarData.fitmentImage"
            class="flex-1 lg:flex-none"
            :class="fitmentCss"
        )
</template>

<script>
import UniversalLink from '@/components/universalLink'
import {
    generateBorderColor,
    generateBackgroundColorClass,
    generateFontColorClass,
} from './helpers'
import FitmentButton from './_components/nav/fitmentButton'
import NavItem from './_components/nav/desktop/navItem.vue'
const AbTestWidget = () =>
    import(/* webpackChunkName: "SB-AbTestWidget" */ './_components/widgets/abtest')

export default {
    name: 'Navbar',
    components: { NavItem, FitmentButton, UniversalLink, AbTestWidget },
    data() {
        return {
            activeMenu: null,
        }
    },
    computed: {
        navbarData() {
            return this.$sitewideData.navbar?.content
        },
        fitmentCss() {
            return [
                generateBackgroundColorClass(this.navbarData.fitmentBackgroundColor),
                generateFontColorClass(this.navbarData.fitmentTextColor),
            ]
        },
        mainCss() {
            const css = [generateBackgroundColorClass(this.navbarData.desktopBackgroundColor)]

            if (
                this.navbarData.desktopBottomBorderColor &&
                this.navbarData.desktopBottomBorderColor !== 'NONE'
            ) {
                css.push('border-b', generateBorderColor(this.navbarData.desktopBottomBorderColor))
            }

            // Determine Z-index
            if (this.$storyblok.isEditing && this.$sitewideData.isNavbarPreview) {
                // We want the navbar above the storyblock click blocker div
                css.push('z-[70]')
            } else {
                css.push('z-10')
            }

            return css
        },
        linkClasses() {
            const fontColor = generateFontColorClass(this.navbarData.desktopTextColor)
            const isActiveFontColor = generateFontColorClass(this.navbarData.desktopHoverTextColor)

            const classes = {
                hover: [`hover:${isActiveFontColor}`],
                open: [isActiveFontColor],
                closed: [fontColor],
            }

            // The classes changed when Open based on hover style
            switch (this.navbarData.desktopHoverStyle) {
                case 'UNDERLINE':
                    const isActiveBorderColor = generateBorderColor(
                        this.navbarData.desktopHoverColor
                    )
                    classes.closed.push('border-b-2', 'border-transparent')
                    classes.open.push(`border-b-2 ${isActiveBorderColor}`)
                    classes.hover.push(`hover:border-b-2 hover:${isActiveBorderColor}`)
                    break
                case 'BACKGROUND':
                    const isActiveBgColor = generateBackgroundColorClass(
                        this.navbarData.desktopHoverColor
                    )

                    classes.open.push(isActiveBgColor)
                    classes.hover.push(`hover:${isActiveBgColor}`)
                    break
            }

            return classes
        },
    },
}
</script>
